import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from '../../../../environments/environment';
import { FacilityConsoleEquipmentsObject } from '../../../core/services/facility.model';
import { FacilityService } from '../../../core/services/facility.service';
import { consoleMapObject } from '../../services/consoleMap.model';
import { GetSoftwarePendingCountService, IPendingCountResponse } from '../../services/get-software-pending-count.service';
import { SelectionInfo } from '../multi-selection/multi-selection.model';

@Component({
  selector: 'app-select-console',
  templateUrl: './select-console.component.html',
  styleUrls: ['./select-console.component.css'],
})
export class SelectConsoleComponent implements OnInit, OnChanges {
  cloudBasePath: string;
  selectedConsole: consoleMapObject | undefined;
  consoleName: string | undefined;
  consoleMaplist: consoleMapObject[] = [];
  consoleListDropdownVisibility = false;
  private isAnyPendingUpdates: boolean;

  @Input() selectionInfo: SelectionInfo;
  @Input() defaultConsoleType: string;
  @Input() isReloadSelectConsoles: boolean;
  @Input() allConsolesEnabled = false;
  @Input() permission: string;
  @Input() isIncludedSmartStrength = false;
  @Input() isIncludedInMultiConsoleComponent = false;
  @Input() isSelectedCardioConsole = false;
  @Output() selectedConsoleEmit: EventEmitter<FacilityConsoleEquipmentsObject> = new EventEmitter<FacilityConsoleEquipmentsObject>();

  constructor(
    private _facilityService: FacilityService,
    private loader: HaloLoaderService,
    private getPendingCountService: GetSoftwarePendingCountService,
    private commonUtil: CommonUtil,
  ) {
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.prepareSelectedConsoleView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.isReloadSelectConsoles?.currentValue) {
      setTimeout(() => this.prepareSelectedConsoleView());
    }
    if (changes.defaultConsoleType?.currentValue != changes.defaultConsoleType?.previousValue) {
      this.selectedConsole = this.consoleMaplist.find(c => c.consoleObj.consoleType == changes.defaultConsoleType?.currentValue);
    } 
  }

  private filterConsoles(consoleList: FacilityConsoleEquipmentsObject[]) {
    if (consoleList) {
      this.consoleMaplist = consoleList
      .map((x) => {
        const obj = {
          consoleName: this.selectionInfo.rootScopeData.consoleRights.get(x.consoleType).consoleName,
          consoleObj: x
        };
        return obj;
      }).sort((a: any,b: any) => +a.consoleObj.consoleOrderId > +b.consoleObj.consoleOrderId ? 1 : -1);

      const listWithNegativeOrderId = this.consoleMaplist.map((item: any) => {
        if (+item.consoleObj.consoleOrderId === - 1) {
          return item;
        }
      }).filter(item => item);

      this.consoleMaplist = this.consoleMaplist.map((item: any) => {
        if (+item.consoleObj.consoleOrderId !== -1) {
           return item 
        }
      }).filter(item => item);

      this.consoleMaplist = [...this.consoleMaplist, ...listWithNegativeOrderId];
      if(this.allConsolesEnabled) {
        const all = [{consoleName:  this.commonUtil.translateText('ALL.CONSOLES'), consoleObj: {
          consoleId: "-1", 
          consoleOrderId: "-1",
          consoleType: "all",
          equipments: this.setAllEquiplent()
        }}];
        this.consoleMaplist.unshift(all[0]);
        this.selectedConsole = all[0];
      } else {
        this.consoleMaplist = this.consoleMaplist
        .filter((consoleMapObj) => this.selectionInfo.rootScopeData.consoleRights.get(consoleMapObj.consoleObj.consoleType)[this.permission] == 'true')
        .filter((consoleMapObj) => {
          if (this.permission === 'hasPerformanceRun') {
            return consoleMapObj.consoleObj.equipments.find((equip: any) => equip.activityId === '1' || equip.activityId === '28');
          }
          if(this.permission === 'hasLfodEnabledEquipment') {
            return consoleMapObj.consoleObj.equipments.filter((equip: any) => !(equip.activityId === '15' || equip.activityId === '-1'))?.length > 0;
          }
          if(this.permission === 'hasAnnouncements') {
            return consoleMapObj.consoleObj.consoleType !== 'hal';
          }
          return consoleMapObj;
        });
        if (this.consoleMaplist.length > 0) {
          this.selectedConsole = this.consoleMaplist.find(c => c.consoleObj.consoleType == this.selectionInfo.consoleType); 
          if(!this.selectedConsole) this.selectedConsole = this.consoleMaplist[0];          
        }
      }
      setTimeout(() => this.selectedConsoleEmit.emit(this.selectedConsole?.consoleObj));

    }
  }

  setAllEquiplent() {
    const tmp: any[] = [];
    this.consoleMaplist.forEach(item => {
      if(item.consoleObj.consoleId !== '-1') {
        tmp.push(...item.consoleObj.equipments)
      }

    });
    return tmp;
  }

  private selectConsole(consoleObj: consoleMapObject) {
    this.consoleListDropdownVisibility = false;
    if(consoleObj.consoleObj.consoleType != this.selectedConsole?.consoleObj.consoleType) {
      if(consoleObj.consoleObj.consoleId === '-1') {
        this.defaultConsoleType = consoleObj.consoleObj.consoleType;
        consoleObj.consoleObj.equipments = [];
        consoleObj.consoleObj.equipments = this.setAllEquiplent();
      } else {
        this.selectedConsole = consoleObj;
        this.defaultConsoleType = consoleObj.consoleObj.consoleType;
        this._facilityService.updatedFacilityPreferenceForUser2({ lastSelectedFacility: this._facilityService.selectedFacilityId, lastSelectedConsole: consoleObj.consoleObj.consoleType });
      }
      this.selectedConsoleEmit.emit(consoleObj.consoleObj);
    }
  }

  private prepareSelectedConsoleView(): void {   
    if (this.permission === 'hasRemoteUpdate') {
      this.prepareSelectedConsoleViewForRemoteUpdate();
    } else {
      const consoleObj = this.getConsoleList();
      this.selectedConsole = undefined;
      this.filterConsoles(consoleObj);
    }    
  }

  private getConsoleList() {
    let consoles: FacilityConsoleEquipmentsObject[] = [];
    this._facilityService.selectedMultiFacilities().forEach(element => {
      const fac = this._facilityService.getFacilityById(element);
      if(fac && fac.consoleEquipments) consoles = consoles.concat(...fac.consoleEquipments);
    });
    return consoles.filter((v, i, a) => a.findIndex(f => f.consoleType === v.consoleType) === i);
  }

  private async prepareSelectedConsoleViewForRemoteUpdate() {
    const consoleObj = this.getConsoleList();
    if(!consoleObj) return;

    this.loader.startProcess();
    this.selectedConsole = undefined;
    let softwareData: IPendingCountResponse | undefined;
    try {
      softwareData = await this.getPendingCountService.getSoftwarePendingCount(this.selectionInfo.facility.facilityId);
    } catch (error) {
      console.error('API error.')
    }
    
    this.loader.endProcess();
    if(softwareData) {
      this.isAnyPendingUpdates = parseInt(softwareData.totalPendingCount) > 0;
      if (this.isAnyPendingUpdates && softwareData.consoleAssetSoftware) {
        consoleObj.forEach(c => {
          softwareData?.consoleAssetSoftware.forEach(a => {
            if (c.consoleType === a.console) {
              c.pendingCount = parseInt(a.pendingCount);
            }
          });
        });
      }    
    }
    
    this.filterConsoles(consoleObj);
  }
}
